import { useState } from "react";
import {
  RiMailLine,
  RiSendPlaneLine,
  RiCheckboxCircleLine,
  RiCalendarLine,
  RiArrowRightLine,
} from "react-icons/ri";
import { useInView } from "../hooks/useInView";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", org: "", message: "" });
  const [submitted, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [ref, visible] = useInView(0.1);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = "Name is required";
    if (!form.email.trim())   e.email   = "Email is required";
    if (!form.message.trim()) e.message = "Message is required";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    
    setLoading(true);
    try {
      const response = await fetch("http://localhost:5000/api/our-fathers/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          subject: form.org ? `New Inquiry from ${form.name} (${form.org})` : `New Inquiry from ${form.name}`,
          message: form.message,
        }),
      });

      if (response.ok) {
        setSubmit(true);
      } else {
        console.error("Failed to send message");
        alert("There was an issue sending your message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Network error. Please check if the backend server is running and try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, val) => {
    setForm((p) => ({ ...p, [field]: val }));
    if (errors[field]) setErrors((p) => ({ ...p, [field]: undefined }));
  };

  return (
    <section id="contact" className="contact section-pad">
      <div className="container">
        <div
          ref={ref}
          className={`contact__grid fade-up ${visible ? "visible" : ""}`}
        >

          {/* ── Left column ── */}
          <div className="contact__info">
            <span className="section-label">Get In Touch</span>
            <h2 className="contact__heading">Let&apos;s Work Together</h2>
            <p className="contact__info-text">
              Whether you need a training partner, evaluation support, or a
              keynote speaker &mdash; reach out and let&apos;s talk about what
              your organization needs to move forward.
            </p>

            <a
              href="mailto:info@ourfathersoursons.org"
              className="contact__detail"
            >
              <span className="contact__detail-icon">
                <RiMailLine />
              </span>
              <span>info@ourfathersoursons.org</span>
            </a>

            {/* Promo card */}
            {/* <div className="contact__promo">
              <div className="contact__promo-icon">
                <RiCalendarLine />
              </div>
              <div className="contact__promo-body">
                <p className="contact__promo-title">
                  Free 30-Minute Consultation
                </p>
                <p className="contact__promo-desc">
                  Prefer to talk first? Book a no-commitment discovery call
                  and we&apos;ll find the right solution together.
                </p>
                <button
                  className="contact__promo-btn"
                  onClick={() =>
                    window.open("https://cal.com/schea91/introcall", "_blank")
                  }
                >
                  Book a Free Call <RiArrowRightLine />
                </button>
              </div>
            </div> */}
          </div>

          {/* ── Right column: form ── */}
          <div className="contact__form-wrap">
            {submitted ? (
              <div className="contact__success">
                <RiCheckboxCircleLine className="contact__success-icon" />
                <h4>Message Received!</h4>
                <p>
                  Thank you for reaching out. We&apos;ll respond within 1&ndash;2
                  business days.
                </p>
              </div>
            ) : (
              <div className="contact__form">
                <div className="contact__form-row">
                  <div className="contact__field">
                    <label>Name *</label>
                    <input
                      placeholder="Your full name"
                      value={form.name}
                      onChange={(e) => handleChange("name", e.target.value)}
                      className={errors.name ? "contact__input--error" : ""}
                    />
                    {errors.name && (
                      <span className="contact__error">{errors.name}</span>
                    )}
                  </div>
                  <div className="contact__field">
                    <label>Email *</label>
                    <input
                      type="email"
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      className={errors.email ? "contact__input--error" : ""}
                    />
                    {errors.email && (
                      <span className="contact__error">{errors.email}</span>
                    )}
                  </div>
                </div>

                <div className="contact__field">
                  <label>Organization</label>
                  <input
                    placeholder="Agency, nonprofit, or organization name"
                    value={form.org}
                    onChange={(e) => handleChange("org", e.target.value)}
                  />
                </div>

                <div className="contact__field">
                  <label>Message *</label>
                  <textarea
                    rows={5}
                    placeholder="Tell us about your needs, goals, timeline, and any questions..."
                    value={form.message}
                    onChange={(e) => handleChange("message", e.target.value)}
                    className={errors.message ? "contact__input--error" : ""}
                  />
                  {errors.message && (
                    <span className="contact__error">{errors.message}</span>
                  )}
                </div>

                <button
                  className="btn-primary contact__submit"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  <RiSendPlaneLine />
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            )}
          </div>
</div>
        </div>
      
    </section>
  );
}